import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CityDetail from './components/CityDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageCity',
  components: {
    CityDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;